import React, { useState, useContext } from "react";
import styles from "../CreateStore/CreateStoreModal.module.css";
import { create } from "../../../hooks/Store";
import { StoresContext } from '../../../context/StoresContext';

function Modal({ closeModal }) {
  const { addStore } = useContext(StoresContext);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [phone, setPhone] = useState("");
  
  const handleCnpjChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    value = value.replace(/^(\d{2})(\d)/, "$1.$2");
    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
    value = value.replace(/(\d{4})(\d)/, "$1-$2");
    setCnpj(value);
  };

  const onSaveClick = async (e) => {
    e.preventDefault(); 
    const response = await create(name, description, cnpj, phone);
    if (response) {
      addStore(true);
      closeModal();
    } else {
      addStore(false);
      closeModal();
    }
  };

  const isFormValid = name && description && cnpj && phone;
  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          <form>
            <label>
              <span>Nome da Loja</span>
              <input
                type="text"
                required
                placeholder="Digite o nome da Loja"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </label>

            <label>
              <span>Descrição</span>
              <input
                type="text"
                required
                placeholder="Digite a descrição da Loja"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </label>

            <label>
              <span>CNPJ (Ex: 90.888.510/0001-30)</span>
              <input
                type="text"
                required
                placeholder="Digite o CNPJ da Loja"
                value={cnpj}
                onChange={ handleCnpjChange }
                maxLength="18"
              />
            </label>

            <label>
              <span>Telefone (Ex: 11957696349)</span>
              <input
                type="text"
                required
                placeholder="Digite o telefone da Loja"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </label>
          </form>
        </div>
        <div className={styles.buttonContent}>
          <button 
            onClick={ onSaveClick } 
            className={styles.buttonConfirm}
            disabled={!isFormValid}
          >
            Salvar Loja
          </button>
          <button onClick={ closeModal } className={styles.buttonCancel}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
